import React from 'react';
import { useTranslation } from 'react-i18next';
import ServicePageLayout from '../../component/common/servicesPagesLayout';

const MobileDevelopmentPage = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: '🍎',
      title: t('mobileDevelopment.features.1.title'),
      description: t('mobileDevelopment.features.1.desc'),
    },
    {
      icon: '🤖',
      title: t('mobileDevelopment.features.2.title'),
      description: t('mobileDevelopment.features.2.desc'),
    },
    {
      icon: '📱',
      title: t('mobileDevelopment.features.3.title'),
      description: t('mobileDevelopment.features.3.desc'),
    },
    {
      icon: '🧪',
      title: t('mobileDevelopment.features.4.title'),
      description: t('mobileDevelopment.features.4.desc'),
    },
    {
      icon: '🔗',
      title: t('mobileDevelopment.features.5.title'),
      description: t('mobileDevelopment.features.5.desc'),
    },
    {
      icon: '📊',
      title: t('mobileDevelopment.features.6.title'),
      description: t('mobileDevelopment.features.6.desc'),
    },
  ];

  const process = [
    { title: t('mobileDevelopment.process.1.title'), description: t('mobileDevelopment.process.1.desc') },
    { title: t('mobileDevelopment.process.2.title'), description: t('mobileDevelopment.process.2.desc') },
    { title: t('mobileDevelopment.process.3.title'), description: t('mobileDevelopment.process.3.desc') },
    { title: t('mobileDevelopment.process.4.title'), description: t('mobileDevelopment.process.4.desc') },
  ];

  const whyChooseUs = [
    { stat: '20+', label: t('mobileDevelopment.why.1.label') },
    { stat: '4.8★', label: t('mobileDevelopment.why.2.label') },
    { stat: '100K+', label: t('mobileDevelopment.why.3.label') },
    { stat: '98%', label: t('mobileDevelopment.why.4.label') },
  ];

  const techStack = [
    { icon: '⚛️', name: 'React Native' },
    { icon: '💙', name: 'Flutter' },
    { icon: '🍏', name: 'Swift' },
    { icon: '🟣', name: 'Kotlin' },
    { icon: '🔥', name: 'Firebase' },
    { icon: '📱', name: 'Expo' },
    { icon: '🧪', name: 'Jest' },
    { icon: '📊', name: 'Analytics' },
    { icon: '🔔', name: 'Push Notifications' },
    { icon: '🗺️', name: 'Maps SDK' },
  ];

  const faqs = [
    {
      question: t('mobileDevelopment.faq.q1'),
      answer: t('mobileDevelopment.faq.a1'),
    },
    {
      question: t('mobileDevelopment.faq.q2'),
      answer: t('mobileDevelopment.faq.a2'),
    },
    {
      question: t('mobileDevelopment.faq.q3'),
      answer: t('mobileDevelopment.faq.a3'),
    },
  ];

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Mobile App Development Services',
    provider: {
      '@type': 'Organization',
      name: 'BringIt Go',
      url: 'https://www.bringitgo.tech',
    },
    description: 'Professional mobile app development for iOS and Android — native and cross-platform solutions with React Native and Flutter.',
    url: 'https://www.bringitgo.tech/mobile-development',
    areaServed: 'Worldwide',
    serviceType: 'Mobile App Development',
  };

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <ServicePageLayout
      accentClass="service-accent-mobile"
      badge={t('mobileDevelopment.badge')}
      title={t('mobileDevelopment.heroTitle')}
      description={t('mobileDevelopment.heroDescription')}
      features={features}
      process={process}
      whyChooseUs={whyChooseUs}
      techStack={techStack}
      faqs={faqs}
      seo={{
        title: t('mobileDevelopment.seo.title'),
        description: t('mobileDevelopment.seo.description'),
        canonical: 'https://www.bringitgo.tech/mobile-development',
      }}
      structuredData={[structuredData, faqStructuredData]}
    />
  );
};

export default MobileDevelopmentPage;
